import { render, staticRenderFns } from "./Location3Editor.vue?vue&type=template&id=25339b16&"
import script from "./Location3Editor.vue?vue&type=script&lang=ts&"
export * from "./Location3Editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports